module.exports = __webpack_public_path__ + "static/media/Minus_Icon.3939f0d9.svg";